export default __webpack_public_path__ + "static/media/wallet-icon.393ca867.svg";